// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.daop-panel {
  border: 1px solid #d1d5db;
  border-radius: 12px;
  background: #ffffff;
  padding: 10px;
}

.daop-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 10px;
}

.daop-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: #111827;
}

.daop-collapse-btn {
  min-width: 30px;
  height: 30px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #111827;
  cursor: pointer;
}

.daop-collapse-btn--collapsed {
  width: 100%;
  height: auto;
  padding: 10px 12px;
  font-weight: 700;
  font-size: 14px;
  color: #111827;
  background: #ffffff;
  text-align: center;
}

.daop-collapsed-wrap {
  width: 100%;
}

.daop-list {
  display: grid;
  gap: 8px;
}

.daop-item-btn {
  width: 100%;
  min-height: 36px;
  padding: 8px 10px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
  background: #f8fafc;
  color: #111827;
  cursor: pointer;
  textAlign: left;
  font-size: 13px;
}

.daop-item-btn:hover {
  background: #eef2ff;
  border-color: #93c5fd;
}`, "",{"version":3,"sources":["webpack://./src/components/designer/DesignerAddObjectPanel.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,QAAQ;EACR,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;AACvB","sourcesContent":[".daop-panel {\n  border: 1px solid #d1d5db;\n  border-radius: 12px;\n  background: #ffffff;\n  padding: 10px;\n}\n\n.daop-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 8px;\n  margin-bottom: 10px;\n}\n\n.daop-title {\n  margin: 0;\n  font-size: 16px;\n  font-weight: 700;\n  color: #111827;\n}\n\n.daop-collapse-btn {\n  min-width: 30px;\n  height: 30px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #111827;\n  cursor: pointer;\n}\n\n.daop-collapse-btn--collapsed {\n  width: 100%;\n  height: auto;\n  padding: 10px 12px;\n  font-weight: 700;\n  font-size: 14px;\n  color: #111827;\n  background: #ffffff;\n  text-align: center;\n}\n\n.daop-collapsed-wrap {\n  width: 100%;\n}\n\n.daop-list {\n  display: grid;\n  gap: 8px;\n}\n\n.daop-item-btn {\n  width: 100%;\n  min-height: 36px;\n  padding: 8px 10px;\n  border: 1px solid #cbd5e1;\n  border-radius: 8px;\n  background: #f8fafc;\n  color: #111827;\n  cursor: pointer;\n  textAlign: left;\n  font-size: 13px;\n}\n\n.daop-item-btn:hover {\n  background: #eef2ff;\n  border-color: #93c5fd;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
